export function loadHandTalk(token) {
	const scriptHandTalk = document.createElement('script')

	scriptHandTalk.src = 'https://plugin.handtalk.me/web/latest/handtalk.min.js'
	scriptHandTalk.async = true

	scriptHandTalk.onload = () => {
		if (typeof HT !== 'undefined') {
			new HT({
				token: token,
			})
		}
	}

	document.body.appendChild(scriptHandTalk)
}

export default loadHandTalk
